const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://169.58.21.41/api';

const headers = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
});

async function call(path, options = {}) {
    const res = await fetch(`${API_URL}/irrigation${path}`, { headers: headers(), ...options });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(body.error || `HTTP ${res.status}`);
    return body;
}

export const waterBalanceService = {
    fetchAll: () => call('/balance'),
    fetchOne: (fieldId, withHours = false) => call(`/${fieldId}/balance${withHours ? '?hours=1' : ''}`),
    saveSettings: (fieldId, patch) => call(`/${fieldId}/balance/settings`, { method: 'PUT', body: JSON.stringify(patch) }),
    recordApplied: (fieldId, amount) => call(`/${fieldId}/balance/applied`, { method: 'POST', body: JSON.stringify(amount) }),
    reset: (fieldId) => call(`/${fieldId}/balance/reset`, { method: 'POST' }),
};
